import React, { useState, useEffect } from "react";
import { useMemo, useRef } from "react";
import { Tooltip, Grid } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";
import SearchIcon from "@material-ui/icons/Search";
import { CloseOutlined } from "@material-ui/icons/";

const columns = [
  {
    field: "ModelCode",
    headerName: "Model Code",
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    width: 170,
  },
  {
    field: "Quantity",
    headerName: "Qty",
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    width: 160,
    type: "number",
    editable: true,
    renderCell: (params) => (
      <Tooltip title={params.row.Quantity} >
        <span className="table-cell-trucate">
          {/* {params.row.Quantity != 1 || params.row.Quantity != 0 ? 1 : params.row.Quantity} */}
          {params.row.Quantity > 1 ? params.row.Quantity : 1}
        </span>
      </Tooltip>
    )
  },
  {
    field: "Description",
    headerName: "Description",
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    width: 180,
    renderCell: (params) => (
      <Tooltip title={params.row.Description} >
        <span className="table-cell-trucate">{params.row.Description}</span>
      </Tooltip>
    )
  },
  {
    field: "Rate",
    headerName: "Rate",
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    width: 160,
    type: "number",
  },
  {
    field: "ListPriceUSD",
    headerName: "UsdRate",
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    width: 160,
    type: "number",
  },
  {
    field: "Amount",
    headerName: "Amount",
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    width: 180,
    type: "number",
    editable: true,
    valueGetter: GetAmount,
    // sortComparator: (v1, v2) => v1.toString().localeCompare(v2.toString()),
  },
  {
    field: "ProductName",
    headerName: "Product",
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    width: 180,
    renderCell: (params) => (
      <Tooltip title={params.row.ProductName} >
        <span className="table-cell-trucate">{params.row.ProductName}</span>
      </Tooltip>
    )
  },
  {
    field: "ProductCat1",
    headerName: "Cat1",
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    width: 180,
    renderCell: (params) => (
      <Tooltip title={params.row.ProductCat1} >
        <span className="table-cell-trucate">{params.row.ProductCat1}</span>
      </Tooltip>
    )
  },

];



function useApiRef() {
  const apiRef = useRef(null);
  const _columns = useMemo(
    () =>
      columns.concat({
        field: "__HIDDEN__",
        width: 0,
        renderCell: (params) => {
          //// debugger;
          apiRef.current = params.api;
          return null;
        },
      }),
    [columns]
  );
  return { apiRef, columns: _columns };
}




function GetAmount(params) {
  var Q = params.getValue(params.id, "Quantity");
  var R = params.getValue(params.id, "Rate");
  let Total = Q * R;
  return Total;
}


// function GetQuantity(params) {
//   var Q = "1";
//   return Q;
// }



const AddProduct = (props) => {
  const [selectionModel, setSelectionModel] = React.useState([]);
  const [cellchanged, setCellchanged] = React.useState([]);
  const [rows, setRows] = useState([]);
  const [row, setRow] = useState([]);
  const { apiRef, columns } = useApiRef();
  // const { apiRef1, columns1 } = useApiRef1();
  const [StateName, setStateName] = useState("");
  // const [CurrencyRate,setCurrencyRate] = useState("");
  const [ConversionRate, setConversionRate] = useState("");
  const [CurrencyID, setCurrencyID] = useState("");
  const [StateResponse, fetchState] = UseFetchData();
  const [ConversionResopnse, fetchConversion] = UseFetchData();
  const [ComboDataResponse, fetchComboData] = UseFetchData();
  const [response, fetchData] = UseFetchData();
  const [ProductListresponse, FetchProductListData] = UseFetchData();
  const [Productcmb, setProductcmb] = useState([]);
  const [ProductGroupcmb, setProductGroupcmb] = useState([]);
  const [ProductCat1cmb, setProductCat1cmb] = useState([]);
  const [ProductCat2cmb, setProductCat2cmb] = useState([]);
  const [ProductCat3cmb, setProductCat3cmb] = useState([]);
  const [ProductCat4cmb, setProductCat4cmb] = useState([]);
  const [ProductID, setProductID] = useState("");
  const [ProductGroupID, setProductGroupID] = useState("");
  const [ProductCat1ID, setProductCat1ID] = useState("");
  const [ProductCat2ID, setProductCat2ID] = useState("");
  const [ProductCat3ID, setProductCat3ID] = useState("");
  const [ProductCat4ID, setProductCat4ID] = useState("");
  const [SearchString, setSearchString] = useState("");
  const [Description, setDescription] = useState("");
  const [Specifications, setSpecifications] = useState("");

  useEffect(() => {
    setRows(ProductListresponse);
  }, [ProductListresponse]);


  //   useEffect(() =>
  //   {
  // set
  //   });


  const validationSchema = Yup.object({
    // OpportunityNo: Yup.string().required('Required!'),
  });


  const onSubmit = async () => {
    // debugger;
    try {
      let gridcolumns = apiRef.current.getRowModels();
      var newSelection = selectionModel;
      let Seq = 0;
      if (selectionModel.length > 0) {
        for (var i = 0; i < newSelection.length; i++) {
          var idd = newSelection[i];
          let iterator = gridcolumns.entries();
          for (let e of iterator) {
            var id = e[0];
            if (idd === id) {
              Seq += 1;
              let Quty = 1;
              let Quantitys = e[1].Quantity;
              var bodyFormData = new FormData();
              bodyFormData.append("OpportunityDtlsID", props.OpportunitydtldID);
              bodyFormData.append("OpportunityID", props.OpportunityID);
              bodyFormData.append("Seq", Seq);
              bodyFormData.append("ProductSKUID", id);
              bodyFormData.append("Description", e[1].Description);
              bodyFormData.append("Specifications", e[1].Specifications);
              if (Quantitys == undefined && Quantitys == null) {
                bodyFormData.append("Quantity", parseFloat(Quty));
              }
              else {
                bodyFormData.append("Quantity", parseInt(e[1].Quantity));
              }
              // bodyFormData.append("Rate", parseFloat(e[1].Rate / ConversionRate));
              bodyFormData.append("Rate", parseFloat(e[1].ListPriceUSD));
              bodyFormData.append("RateINR", parseFloat(e[1].Rate));
              bodyFormData.append("DiscountPer", "0");
              bodyFormData.append("DiscountAmt", "0");
              bodyFormData.append("CurrencyID", CurrencyID);
              bodyFormData.append("ConvFactor", parseFloat(ConversionRate));
              bodyFormData.append("CUrrencyRate", "0");
              // bodyFormData.append("Amount", e[1].Quantity * e[1].Rate);
              if (Quantitys == undefined && Quantitys == null) {
                bodyFormData.append("Amount", Quty * e[1].Rate);
              }
              else {
                bodyFormData.append("Amount", e[1].Quantity * e[1].Rate);
              }
              bodyFormData.append("CgstPer", parseFloat(e[1].GstPer));
              bodyFormData.append("CgstAmt", "0");
              bodyFormData.append("SgstPer", parseFloat(e[1].GstPer));
              bodyFormData.append("SgstAmt", "0");
              bodyFormData.append("SgstPer", parseFloat(e[1].GstPer));
              bodyFormData.append("IgstAmt", "0");
              bodyFormData.append("StateName", StateName);
              bodyFormData.append("NetWeight", parseFloat(e[1].Weight_kg));
              if (Quantitys == undefined && Quantitys == null) {
                bodyFormData.append("TotalAmount", Quty * e[1].ListPriceUSD);
              }
              else {
                bodyFormData.append("TotalAmount", e[1].Quantity * e[1].ListPriceUSD);
              }
              // bodyFormData.append("TotalAmount", e[1].Quantity * e[1].Rate);
              // bodyFormData.append("TotalAmountINR",e[1].Quantity * e[1].Rate)
              await fetchData("Opportunity/AddProduct", bodyFormData);
            }
          }
        }
        props.getByIDData()
        alert("Product added Succesfully.");
        //props.setOpen(false);
      } else {
        alert("Please Select Product To Add");
      }
    }
    catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (response.Response === true) {
      // props.setOpen(false);
      setProductID("");
      setProductGroupID("");
    } else if (response.Response === false) {
      if (response.Message.includes("Already") === true) {
        alert(response.Message);
      } else {
        alert("Failed.");
      }
    }
  }, [response]);


  const ProductData = (options) => {
    if (options !== undefined) {
      let Product = options.map((data) => (
        <option key={data.ProductName} value={data.ProductID}>
          {data.ProductName}
        </option>
      ));
      setProductcmb(Product);
    }
  };

  const ProductGroupData = (options) => {
    if (options !== undefined) {
      let ProductGroup = options.map((data) => (
        <option key={data.ProductGroup} value={data.ProductGroupID}>
          {data.ProductGroup}
        </option>
      ));
      setProductGroupcmb(ProductGroup);
    }
  };



  useEffect(() => {
    if (ComboDataResponse !== undefined) {
      if (ComboDataResponse["Product"] !== undefined) {
        ProductData(ComboDataResponse["Product"]);
      }
      if (ComboDataResponse["ProductGroup"] !== undefined) {
        ProductGroupData(ComboDataResponse["ProductGroup"]);
      }
    }
  }, [ComboDataResponse]);

  useEffect(() => {
    GetComboData();
  }, [ProductID, ProductGroupID]);

  useEffect(() => {
    // debugger;
    if (StateResponse !== undefined) {
      if (StateResponse["StateData"] !== undefined) {
        // debugger;
        setStateName(StateResponse["StateData"][0]["StateName"]);
        // debugger;
      }
    }
  }, [StateResponse]);


  useEffect(() => {
    // debugger;
    if (ConversionResopnse !== undefined) {
      if (ConversionResopnse["ConversionData"] !== undefined) {
        // debugger;
        setConversionRate(ConversionResopnse["ConversionData"][0]["ConversionRate"]);
        setCurrencyID(ConversionResopnse["ConversionData"][0]["CurrencyID"])
      }
    }
  }, [ConversionResopnse]);


  useEffect(() => {
    // GetComboData();
    GetStateDate();
    GetConversionDate();
  }, []);


  const GetStateDate = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("OpportunityID", props.OpportunityID);
    fetchState("Opportunity/StateData", bodyFormData);
  }


  const GetConversionDate = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("OpportunityID", props.OpportunityID);
    fetchConversion("Opportunity/ConversionData", bodyFormData);
  }


  const GetComboData = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("ProductID", ProductID);
    bodyFormData.append("ProductGroupID", ProductGroupID);
    fetchComboData("Opportunity/ComboDataAddPro", bodyFormData);
  };


  const onSelectChange = (e) => {
    debugger;
    let targetvalue = e.target.value;
    let targetname = e.target.name;
    if (targetvalue !== "") {
      if (targetname === "ProductID") {
        setProductID(targetvalue);
        // setProductGroupID("");
      }
      if (targetname === "ProductGroupID") {
        setProductGroupID(targetvalue);
      }
    }
    else {
      if (targetname === "ProductID") {
        setProductID("");
        setProductGroupID("");
      }
      if (targetname === "ProductGroupID") {
        setProductGroupID("");
      }
    }
  };

  const PopulateData = () => {
    debugger;
    var bodyFormData = new FormData();
    bodyFormData.append("OpportunitydtlsID", props.OpportunitydtldID);
    bodyFormData.append("SearchString", SearchString);
    bodyFormData.append("ProductID", ProductID);
    bodyFormData.append("ProductGroupID", ProductGroupID);
    bodyFormData.append("Description", Description);
    FetchProductListData("Opportunity/ProductList", bodyFormData);
  };

  const handleCellEditCommit = React.useCallback(

    ({ id, field, value }) => {

      setCellchanged(value)

      if (field === "Amount") {
        const [Quantity, Rate] = value.toString().split(" ");
        const updatedRows = rows.map((row) => {
          if (row.id === id) {
            return { ...row, Quantity, Rate };
          }
          return row;
        });
        setRows(updatedRows);
      }

    },
    [rows]
  );



  useEffect(() => {
    // setRow(selectionModel);
    if (selectionModel.length > 0) {
      let gridcolumns = apiRef.current.getRowModels();
      let iterator = gridcolumns;
      let data = Array.from(iterator);
      data = Object.values(data);
      data = Object.keys(data).map(key => (data[key][1]))
      const filterOptions = selectionModel;
      let result = data.filter(function (e) {
        return filterOptions.includes(e.id)
      });
      setRow(result);
      // console.log(result);

    }
  }, [selectionModel, cellchanged]);



  return (
    <Grid xs={12}>
      <Formik
        initialValues={{}}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {(formik) => {
          return (
            <Form>
              <Grid spacing={2} container direction="row" xs={12}>
                <Grid item xs={1}>
                  <label
                    htmlFor={"ProductGroupID"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"ProductGroup"}
                  </label>
                </Grid>
                <Grid item xs={3}>
                  <BiztranControlsFormik
                    control="select"
                    name="ProductGroupID"
                    options={ProductGroupcmb}
                    onChange={onSelectChange}
                  />
                </Grid>
                <Grid item xs={1}>
                  <label
                    htmlFor={"ProductID"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Product"}
                  </label>
                </Grid>
                <Grid item xs={3}>
                  <BiztranControlsFormik
                    control="select"
                    name="ProductID"
                    options={Productcmb}
                    onChange={onSelectChange}
                  />
                </Grid>
                <Grid item xs={4}></Grid>
                <Grid item xs={1}>
                  <label
                    htmlFor={"Description"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Description"}
                  </label>
                </Grid>
                <Grid item xs={3}>
                  <BiztranControlsFormik
                    control="input"
                    type="text"
                    name="Description"
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </Grid>
                <Grid item xs={1}>
                  <label
                    htmlFor={"SearchString"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Model_Code"}
                  </label>
                </Grid>
                <Grid item xs={3}>
                  <BiztranControlsFormik
                    control="input"
                    type="text"
                    name="SearchString"
                    onChange={(e) => setSearchString(e.target.value)}
                  />
                </Grid>
                {/* <Grid item xs={4}></Grid>
                <Grid item xs={1}>
                  <label
                    htmlFor={"Specifications"}
                    style={{
                      display: "block",
                      width: "100%",
                    }}
                  >
                    {"Specifications"}
                  </label>
                </Grid>
                <Grid item xs={3}>
                  <BiztranControlsFormik
                    control="input"
                    type="text"
                    name="Specifications"
                    onChange={(e) => setSpecifications(e.target.value)}
                  />
                </Grid> */}
                <Grid item xs={4}>
                  <BiztranControls.Button
                    text="SEARCH"
                    startIcon={<SearchIcon />}
                    style={{ marginTop: "0%" }}
                    onClick={() => {
                      PopulateData();
                    }}
                  />
                </Grid>
              </Grid>
              <Grid spacing={2} container direction="row">
                <Grid xs={12}>
                  <BiztranControls.DataGrid
                    rowHeight={25}
                    rows={rows}
                    columns={columns}
                    hideFooterPagination={true}
                    checkboxSelection
                    disableSelectionOnClick
                    onSelectionModelChange={(newSelection) => {
                      setSelectionModel(newSelection);
                    }}
                    onCellEditCommit={handleCellEditCommit}
                    Height="390px"
                    Width="100%"
                  />
                </Grid>
                {/* <Grid spacing={1} container style={{ marginTop: 7, paddingRight: 10 }}>
                  <BiztranControls.DataGrid
                    rowHeight={25}
                    rows={row}
                    columns={columns1}
                    hideFooterPagination={true}
                    Height="150px"
                    Width="100%"
                  />
                </Grid> */}
                {/* <Grid item xs={3} container direction="row">
                  <h5 style={{ width: 110 }}>Selected Item:{}</h5>
                 </Grid> */}
                <Grid xs={12} style={{ marginTop: 7 }}>
                  <div style={{ width: "100%" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignContent: "center",
                      }}
                    >
                      <BiztranControls.Button
                        text="Add"
                        startIcon={<SaveIcon />}
                        style={{ marginTop: "0%" }}
                        onClick={() => {
                          onSubmit();
                        }}
                      />
                      <BiztranControls.Button
                        text="Close"
                        startIcon={<CloseOutlined />}
                        style={{ marginTop: "0%" }}
                        onClick={() => props.setOpen(false)}
                      />
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Form>
          );
        }}
      </Formik>
    </Grid>
  );
};

export default AddProduct;
